import React, { useState } from "react";
import { Box, Chip, TextField, Autocomplete, Checkbox } from "@mui/material";

function fuzzyFilter(options, inputValue) {
  if (!inputValue) return options;
  const lowerInput = inputValue.toLowerCase();
  const prefix = [];
  const fuzzy = [];
  options.forEach((option) => {
    const lowerOption = option.toLowerCase();
    if (lowerOption.startsWith(lowerInput)) {
      prefix.push(option);
    } else if (lowerOption.includes(lowerInput)) {
      fuzzy.push(option);
    }
  });
  return [...prefix, ...fuzzy];
}

const FilterField = ({ label, options, value = [], onChange }) => {
  const opts = Array.isArray(options) ? options : [];
  const selectedValues = Array.isArray(value) ? value : value ? [value] : [];
  const [inputValue, setInputValue] = useState("");

  return (
    <Box>
      <Autocomplete
        multiple
        disableCloseOnSelect
        options={opts}
        value={selectedValues}
        onChange={(event, newValue) => onChange(newValue)}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
        filterOptions={(opts, state) => fuzzyFilter(opts, state.inputValue)}
        renderOption={(props, option, { selected }) => {
          const { key, ...otherProps } = props;
          return (
            <li key={key} {...otherProps}>
              <Checkbox style={{ marginRight: 8 }} checked={selected} />
              {option}
            </li>
          );
        }}
        renderTags={() => null}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={
              selectedValues.length > 0 ? "" : `Select ${label.toLowerCase()}`
            }
            fullWidth
            autoComplete="off"
          />
        )}
        sx={{ width: "100%" }}
      />
      {/* Showing selected chips below the search box */}
      <Box mt={1} display="flex" flexWrap="wrap" gap={1}>
        {selectedValues.map((chip) => (
          <Chip
            key={chip}
            label={chip}
            onDelete={() => onChange(selectedValues.filter((c) => c !== chip))}
            sx={{ mb: 0.5 }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default FilterField;
